import { render, staticRenderFns } from "./FindCourses.vue?vue&type=template&id=61aaa80a"
import script from "./FindCourses.vue?vue&type=script&lang=js"
export * from "./FindCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports